import React from "react";
import { InputNumber } from 'primereact/inputnumber';
import styled from "styled-components";
import media from "../utils/media";
import classNames from "classnames";

const Container = styled.div`
  input {
    min-width: ${(p) => p.minWidth};

    ${media.xs`
      min-width: 100%;
    `}
  }
`;

function inputNumber({ errorMsg, disabled, className, containerClassName, onChange, value, name, label, required = false, useGrouping, minFractionDigits, maxFractionDigits, minWidth = "250px", maxLength, keyfilter, minValue=null }) {
  return (
    <Container minWidth={minWidth} className={containerClassName}>
      <span className="p-float-label">
        <InputNumber disabled={disabled} minFractionDigits={minFractionDigits? minFractionDigits : null} maxFractionDigits={maxFractionDigits ? maxFractionDigits : null} id={name} value={value} name={name} onValueChange={onChange} useGrouping={useGrouping} autoComplete="off" className={classNames(className, { "p-invalid": errorMsg })} maxLength={maxLength} keyfilter={keyfilter} min={0} mode="decimal" locale="de-DE"/>
        <label htmlFor={name}>
          {errorMsg && <span className="text-pink-500">*</span>}
          {label}
        </label>
      </span>
      {errorMsg && errorMsg}
    </Container>
  );
}

export default inputNumber;
